import React from 'react';
import BadgeWithCrossIcon from 'reusable-components/icons/fullcolor/BadgeWithCrossIcon';

const CSS = require('./CloseButton.module.scss');

function CloseButton({ onClick }: { onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={CSS.CloseButton}
      aria-label="Close dialog"
    >
      <BadgeWithCrossIcon variant="dialog" />
    </button>
  );
}

export default CloseButton;
